import { ReactElement, useState } from "react";
import { LINKS, URL } from "myconstants";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { UndevelopedBuildingZones as ZoningPlanLegalUndevelopedBuildingZones } from "components/zoning-plan-legal/UndevelopedBuildingZones";
import { Parameters } from "components/zoning-plan-legal/Parameters";
import { Calculation } from "components/zoning-plan-legal/Calculation";
import { useEffect } from "react";
import { Action, State } from "../../state/state";
import { Navigation } from "components/common/Navigation";
import { ParameterSetDto, ScenarioDto } from "dtos/dtos";
import { Overlay } from "components/common/Overlay";

export function ZoningPlanLegal(props: {
  dispatch: (action: Action) => void;
  state: State;
}): ReactElement {
  const dispatch = props.dispatch;
  const state = props.state;
  const location = useLocation();
  const [loadError, setLoadError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    async function loadScenario(bfsNr: number) {
      try {
        setLoading(true);

        const responseScenario = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/scenarios/bfsNr/${bfsNr}?status=inKraft&latestOnly=true`,
          {
            credentials: "include",
          }
        );

        if (responseScenario.ok) {
          const scenarios: ScenarioDto[] = await responseScenario.json();

          if (scenarios.length === 1) {
            const scenario = scenarios[0];

            const responseParameterSet = await fetch(
              `${process.env.REACT_APP_API_BASE_URL}/parametersets/scenarioId/${scenario.id}?activeOnly=true`,
              {
                credentials: "include",
              }
            );

            if (responseParameterSet.ok) {
              const parameterSets: ParameterSetDto[] =
                await responseParameterSet.json();

              if (parameterSets.length === 1) {
                dispatch({
                  type: "setScenarioAndParameterSetLegal",
                  data: {
                    scenario: scenario,
                    parameterSet: parameterSets[0],
                  },
                });
              }
            } else {
              setLoadError(true);
            }
          }
        } else {
          setLoadError(true);
        }
      } catch {
        setLoadError(true);
      } finally {
        setLoading(false);
      }
    }

    if (state.selectedMunicipality?.bfsNr !== undefined) {
      loadScenario(state.selectedMunicipality.bfsNr);
    }

    return () => setLoadError(false);
  }, [state.selectedMunicipality?.bfsNr, dispatch]);

  if (loadError) {
    return <Redirect to={URL.error} />;
  }

  if (state.selectedMunicipality === undefined) {
    return <Redirect to={URL.selectMunicipality} />;
  }

  return (
    <main className="flex flex-row grow w-full z-20 self-start">
      <Overlay show={loading} text="Lade Daten ..." />
      <Navigation />
      <div className="flex flex-row space-x-8 w-3/4 bg-white px-8 py-8">
        <div className="flex flex-col w-full">
          <h1 className="mb-4 pb-2 text-gray-400 border-b">
            <span className="font-bold">
              Gemeinde {state.selectedMunicipality?.gemeinde}
            </span>{" "}
            &gt; Rechtskräftiger Zonenplan &gt; {LINKS[location.pathname]}
          </h1>
          {!loading && (
            <Switch>
              <Route exact path={URL.zoningPlanLegalCalculation}>
                <Calculation dispatch={dispatch} state={state} />
              </Route>
              <Route exact path={URL.zoningPlanLegalUndevelopedBuildingZones}>
                <ZoningPlanLegalUndevelopedBuildingZones state={state} />
              </Route>
              <Route exact path={URL.zoningPlanLegalSiteSpecificValues}>
                <Parameters dispatch={dispatch} state={state} />
              </Route>
            </Switch>
          )}
        </div>
        <div className="border border-black border-solid w-20 h-20 shrink-0">
          <img
            src={`${process.env.PUBLIC_URL}/images/coat-of-arms/${state.selectedMunicipality?.bfsNr}.gif`}
            alt="Wappen"
          />
        </div>
      </div>
    </main>
  );
}
